window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

window.transitionEnd = transitionEvent()

require('./vue')

let scrollFromTop = document.documentElement.scrollTop,
    navbar = document.querySelector('.navbar'),
    scrollClass = 'is-scrolling',
    mainNavScrollHeight = 60;

if (scrollFromTop > 0) {
    if (navbar) {
        navbar.classList.add(scrollClass)
    }
}

window.onscroll = function () {
    let el = document.scrollingElement || document.documentElement
    let scrollPosition = el.scrollTop

    if (navbar) {
        if (scrollPosition >= mainNavScrollHeight && ! navbar.classList.contains(scrollClass)) {
            navbar.classList.add(scrollClass)
        } else if (scrollPosition == 0 && navbar.classList.contains(scrollClass)) {
            navbar.classList.remove(scrollClass)
        }
    }
}

function transitionEvent() {
    let el = document.createElement("div")

    if (el.style.OTransition) return "otransitionend"
    if (el.style.WebkitTransition) return "webkitTransitionEnd"
    
    return "transitionend"
}

window.Scroll = new SmoothScroll("[data-scroll]");

var handleScrollStopEvent = function () {
	window.App.$store.state.mainMenu.status = false
}

document.addEventListener('scrollStop', handleScrollStopEvent, false)

let map = document.querySelector('#map')

window.initMap = function (lat, lng) {
    if (map && !isNaN(lat) && !isNaN(lng)) {
        var location = {lat: lat, lng: lng}
        var gMap = new google.maps.Map(map, {zoom: 12, center: location})
        var marker = new google.maps.Marker({position: location, map: gMap})
    }
}
